import classNames from 'classnames'
import { ReactElement } from 'react'

export function EmptySearch({
  title,
  description,
  className,
  titleSize = `sm`,
  icon,
}: {
  title: string
  description?: string | ReactElement
  className?: string
  titleSize?: `sm` | `md` | `lg`
  icon: (...args: any) => ReactElement | ReactElement
}): ReactElement {
  return (
    <div className={classNames(`flex flex-col items-center gap-y-2 space-y-2 align-middle`, className)}>
      <div className="text-trn-800">{icon()}</div>
      <span
        className={classNames(
          `text-black`,
          { 'text-heading-sm': titleSize === `sm` },
          { 'text-heading-md': titleSize === `md` },
          { 'text-center text-[32px] font-semibold md:text-left': titleSize === `lg` },
        )}
      >
        {title}
      </span>
      {description && <p className="whitespace-pre-line text-center text-body-sm text-trn-600">{description}</p>}
    </div>
  )
}
